<!--  -->
<template>
  <div>
    <con-header></con-header>
    <router-view></router-view>
    <com-footer></com-footer>
  </div>
</template>

<script>
import conHeader from "@/components/conHeader";
import comFooter from "@/components/comFooter";
export default {
  name: "home",
  components: { conHeader, comFooter },
  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
</style>


// WEBPACK FOOTER //
// src/view/home.vue